export default {
  namespaced: true,
  state: {
    initialized: false,
    clientList: [],
  },
  getters: {
    
  },
  mutations: {
    setInitialized(state, data) {
      state.initialized = data;
    },
    setClientListData(state, data) {
      state.clientList.splice(0);
      for (const d of data) {
        state.clientList.push(d);
      }
    },
    updateClient(state, data) {
      for (let i=0;i<state.clientList.length;i++) {
        if (state.clientList[i].serial === data.serial) {
          state.clientList.splice(i, 1, data);
          return;
        }
      }
      state.clientList.push(data);
    },
  },
  actions: {
    async initClientList({ commit, dispatch, state }) {
      if (state.initialized) {
        return;
      }
      const res = await dispatch('api/getClientListPromise', null, { root: true });
      commit('setClientListData', res);
      commit('setInitialized', true);
    },
    async refreshClientList({ commit, dispatch }) {
      const res = await dispatch('api/getClientListPromise', null, { root: true });
      // console.log(res)
      commit('setClientListData', res);
    },
    async clientSync({commit, dispatch}, ary) {
      const res = await dispatch('api/postClientSyncPromise', ary, { root: true });
      for (const client of res) {
        commit('updateClient', client);
      }
      // console.log(res);
    },
  }

}
